import * as ActionTypes from "../action-types";

const payroll_defaultState = {
  byID: {},
  byCoid: {},
  allIDs: [],
};

export const payroll = (state = payroll_defaultState, action) => {
  let newState = JSON.parse(JSON.stringify(state));

  if (!action) return newState;

  switch (action.type) {
    case ActionTypes.PAYROLL_GET_ALL: {
      const payrolls = action.payroll;

      payrolls &&
        payrolls.length &&
        payrolls.map((payroll) => {
          const { prid } = payroll;

          newState.byID[prid] = payroll;

          if (!newState.allIDs.includes(prid)) newState.allIDs.push(prid);

          return null;
        });

      return newState;
    }
    case ActionTypes.PAYROLL_GET_ALL_BY_COID: {
      const payrolls = action.payroll;

      payrolls &&
        payrolls.length &&
        payrolls.map((payroll) => {
          const { prid } = payroll;

          newState.byCoid[prid] = payroll;

          if (!newState.allIDs.includes(prid)) newState.allIDs.push(prid);

          return null;
        });

      return newState;
    }
    case ActionTypes.UPDATE_PAYROLL: {
      const payroll = action.payroll;
      const { prid } = payroll;

      if (prid) {
        newState.byID[prid] = { ...newState.byID[prid], ...payroll };
      }

      return newState;
    }
    case ActionTypes.UPDATE_BULK_PAYROLL: {
      const payrolls = action.payrolls;

      if (Array.isArray(payrolls)) {
        payrolls.forEach((payroll) => {
          const { prid } = payroll;

          newState.byID[prid] = { ...newState.byID[prid], ...payroll };
        });
      }

      return newState;
    }
    case ActionTypes.UPDATE_REMARKCOUNT_PAYROLL: {
      const remark = action.remark;

      const { refid, remarkCount } = remark;

      if (refid) {
        newState.byID[refid] = {
          ...newState.byID[refid],
          remarkCount: remarkCount,
        };
      }

      return newState;
    }
    case ActionTypes.UPDATE_PAYROLL_FILE_CLOSE:{
      const payrolls = action.payrolls;

      if (Array.isArray(payrolls)) {
        payrolls.forEach((payroll) => {
          const { prid } = payroll;

          newState.byID[prid] = { ...newState.byID[prid], ...payroll };
        });
      }

      return newState;
    }
    default: {
      return state;
    }
  }
};
